import React from 'react';
import { InfoCircleOutlined } from '@ant-design/icons';
import Typography from 'style-guide/component/Typography';
import Button from 'style-guide/component/Button';
import { ExamplePopupProps } from '../types/questionTypes';

const ExamplePopup: React.FC<ExamplePopupProps> = ({
  visible,
  onUseExample,
  onClose,
}) => {
  if (!visible) return null;

  return (
    <div className="absolute top-20 left-full ml-4 z-30">
      <div className="flex flex-col gap-2 p-4 rounded-lg shadow-md border bg-white w-[320px]">
        <div className="flex gap-2">
          <InfoCircleOutlined className="text-[#52C41A]" />
          <Typography variant="Base" text="Add suggested example" strong />
        </div>
        <Typography
          variant="Base"
          text="We make it easy – add a suggested example that you can edit."
        />
        <div className="flex gap-2 justify-end">
          <Button
            type="Default"
            buttonText="No"
            onClick={onClose}
            className="w-fit"
          />
          <Button
            type="Primary"
            buttonText="Yes"
            onClick={onUseExample}
            className="w-fit"
          />
        </div>
      </div>
    </div>
  );
};

export default ExamplePopup;
